import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const PositionGroups = {
  PositionGroupsList: lazyNamed(() => import('./pages/PositionGroupsList/index.tsx'), 'PositionGroupsList'),
  PositionGroupForm: lazyNamed(() => import('./pages/PositionGroupForm/index.tsx'), 'PositionGroupForm'),
  PositionsForm: lazyNamed(() => import('./pages/PositionsForm/index.tsx'), 'PositionsForm'),
};
